module.exports = __webpack_public_path__ + "static/media/surface_img-min.9499b19e.jpg";